import React from 'react';
import { Replica } from 'entities/tavus/replica';
import { cn } from 'shared/lib';
import noAvatar from 'shared/ui/img/no-avatar.png';
import { tavusPersonaStore } from 'entities/tavus/persona';

type AvatarItemProps = {
  replica: Replica;
  onChooseReplica: (replica: Replica) => void;
  isActive?: boolean;
};

export const AvatarListItem: React.FC<AvatarItemProps> = ({
  replica,
  onChooseReplica,
  isActive
}) => {
  const { setContainPreview } = tavusPersonaStore();
  const handleChooseAvatar = () => {
    onChooseReplica(replica);
    if (
      replica?.yepic_avatar_type === 'Full Body' ||
      replica?.yepic_avatar_type === 'Video Call'
    ) {
      setContainPreview(false);
    } else if (replica?.yepic_avatar_type === 'Vertical Selfie') {
      setContainPreview(true);
    }
  };
  return (
    <div
      onClick={handleChooseAvatar}
      className={cn(
        `ag-relative ag-group ag-truncate ag-group`,
        isActive ? 'ag-cursor-default' : 'ag-cursor-pointer'
      )}
    >
      <img
        className={cn(
          'ag-w-full ag-select-none ag-pointer-events-none group-hover:ag-border-vivid-purple ag-duration-200 group-active:ag-scale-95 ag-aspect-video ag-border-[1.35px] ag-rounded-[6.1px] ag-h-24',
          isActive ? 'ag-border-vivid-purple' : 'ag-border-neutral-100',
          replica.yepic_avatar_type === 'Full Body' ||
            replica.yepic_avatar_type === 'Vertical Selfie'
            ? 'ag-object-contain'
            : 'ag-object-cover'
        )}
        src={(replica?.thumbnail_urls?.[0] as any) || noAvatar}
      />
      <span
        className={cn(
          'ag-text-neutral-600 ag-select-none ag-text-sm ag-font-medium group-hover:ag-text-vivid-purple ag-duration-200 ag-inline ag-bottom-2 ag-left-2 ',
          isActive ? ' ag-text-vivid-purple' : ''
        )}
      >
        {replica?.yepic_name || replica?.replica_name}
      </span>
    </div>
  );
};
